import { useSite } from "../../context/SiteContext";
import { Reveal } from "../Reveal";

const BG = [
    { bg: "bg-[#0A0A0A]", text: "text-white", sub: "text-white/65", outline: "text-outline-w-soft" },
    { bg: "bg-[#D60024]", text: "text-[#0A0A0A]", sub: "text-black/70", outline: "text-outline-b-soft" },
    { bg: "bg-[#F4F3EF]", text: "text-[#0A0A0A]", sub: "text-black/65", outline: "text-outline-b-soft" },
    { bg: "bg-[#0A0A0A]", text: "text-white", sub: "text-white/65", outline: "text-outline-w-soft" },
];

export default function Territory() {
    const { site, tx } = useSite();
    const c = site?.content || {};
    const items = c.territory || [];

    return (
        <section id="territory" data-testid="territory-section" className="relative">
            {items.map((item, i) => {
                const t = BG[i % BG.length];
                return (
                    <div key={item.num || i} data-testid={`territory-block-${i}`} className={`${t.bg} ${t.text} px-6 py-24 md:px-12 md:py-36 lg:px-24`}>
                        <div className="grid items-center gap-12 md:grid-cols-12">
                            <div className="md:col-span-3">
                                <span className={`font-display block text-[clamp(6rem,14vw,12rem)] leading-[0.8] md:sticky md:top-28 ${t.outline}`}>
                                    {item.num}
                                </span>
                            </div>
                            <div className="md:col-span-5">
                                <Reveal>
                                    <p className="text-[11px] font-semibold uppercase tracking-[0.3em] opacity-60">{tx(item.title1)}</p>
                                    <h3 className="font-display mt-3 text-[clamp(2.8rem,6vw,5.5rem)] leading-[0.85]">{tx(item.title2)}</h3>
                                    <p className={`mt-8 max-w-md text-base leading-relaxed ${t.sub}`}>{tx(item.text)}</p>
                                </Reveal>
                            </div>
                            <div className="md:col-span-4">
                                <Reveal delay={0.15}>
                                    <div className="group overflow-hidden">
                                        <img
                                            src={item.image}
                                            alt=""
                                            loading="lazy"
                                            className="aspect-[3/4] w-full object-cover grayscale transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                                        />
                                    </div>
                                </Reveal>
                            </div>
                        </div>
                    </div>
                );
            })}
        </section>
    );
}
